
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/stock",
      function () {
        return require("private-next-pages/en/ir/stock/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ir/stock"])
      });
    }
  